"use client";

import React from "react";
import MCMComboboxAssetsOnlyExample from "@/examples/MCMComboboxAssetsOnlyExample";

export default function MCMComboboxAssetsOnlyExamplePage() {
  return (
    <div className="container mx-auto p-6">
      <MCMComboboxAssetsOnlyExample />
    </div>
  );
}
